import type {SupportedCurrency} from 'src/v2/state/types';

export const getDepositAddress = ({
  selectedAsset,
  depositAddresses,
}: {
  selectedAsset: SupportedCurrency;
  depositAddresses: Record<string, string>;
}) => {
  // Try both possible asset key formats
  const newAssetKeyFormat = `${selectedAsset.assetCode}.${selectedAsset.currencyNetwork}`;
  const oldAssetKeyFormat = selectedAsset.currencyNetwork;

  if (depositAddresses[newAssetKeyFormat]) {
    return depositAddresses[newAssetKeyFormat];
  } else if (depositAddresses[oldAssetKeyFormat]) {
    return depositAddresses[oldAssetKeyFormat];
  } else {
    throw new Error('Deposit address not found');
  }
};
